"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _actions = require("./store/actions");
var modalLoader = function modalLoader(_ref) {
  var key = _ref.key,
    getModal = _ref.getModal;
  return function (onClose, props, mapActions2Store) {
    return (0, _actions.load)({
      getModal: getModal,
      key: key,
      mapActions2Store: mapActions2Store,
      props: props,
      onClose: onClose
    });
  };
};
var _default = exports.default = modalLoader;